import { FoaPart, Regulation } from "../../../../../autogen/bff-api";
import type { ValueJudgedBy } from "./thresholdValue";

export type EspdRequirement =
  | { required: "unknown" }
  | { required: true; value: string; judgedBy: ValueJudgedBy }
  | { required: false; value: string; judgedBy: ValueJudgedBy; aboveEea: boolean; utilitiesPartIII?: boolean };

// Mirrors the BFF's buyerChoosesEspd (FoaPart.kt). FOA § 17-1 requires it in Part III, not in Part IV;
// forsyningsforskriften requires it in del II, having no national tier (§ 5-2), but kapittel 26 (del III) does not.
const ESPD_REQUIRED_PARTS: Record<Regulation, ReadonlySet<FoaPart>> = {
  [Regulation.Foa]: new Set([FoaPart.PartIii]),
  [Regulation.Forsyningsforskriften]: new Set([FoaPart.PartIi, FoaPart.PartIv]),
  [Regulation.Konsesjonskontraktforskriften]: new Set(),
};

export function computeEspdRequirement(
  regulation: Regulation | null | undefined,
  foaPart: FoaPart | null | undefined,
  valueNok: number | null | undefined,
  judgedBy: ValueJudgedBy = "estimate",
): EspdRequirement {
  if (regulation == null || foaPart == null || valueNok == null) {
    return { required: "unknown" };
  }
  const value = formatNok(valueNok);
  if (ESPD_REQUIRED_PARTS[regulation].has(foaPart)) return { required: true, value, judgedBy };
  const utilitiesPartIII = regulation === Regulation.Forsyningsforskriften && foaPart === FoaPart.PartIii;
  const aboveEea = (regulation === Regulation.Foa && foaPart === FoaPart.PartIv) || utilitiesPartIII;
  return { required: false, value, judgedBy, aboveEea, ...(utilitiesPartIII ? { utilitiesPartIII } : {}) };
}

function formatNok(value: number): string {
  return new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(value);
}
